// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { ContactRelationshipModel } from '../_models/contact-relationship.model';
import { ContactModel, Doctor, FacilityModel, PatientModel } from '..';

export enum ContactRelationshipActionTypes {
  ContactRelationshipOnServerCreated = '[Edit ContactRelationship Dialog] ContactRelationship On Server Created',
  ContactRelationshipCreated = '[Edit ContactRelationship Dialog] ContactRelationship Created',
  ContactRelationshipOnServerUpdated = '[Edit ContactRelationship Dialog] ContactRelationship On Server Updated',
  ContactRelationshipUpdated = '[Edit ContactRelationship Dialog] ContactRelationship Updated',
  ContactRelationshipStoreUpdated = '[Edit ContactRelationship Dialog] ContactRelationship Updated | Only on storage',
  OneContactRelationshipOnServerDeleted = '[Contact Relationships List Page]  One Contact Relationship On Server Deleted',
  OneContactRelationshipDeleted = '[Contact Relationships List Page]  One Contact Relationship Deleted',
  ContactRelationshipsPageRequested = '[Contact Relationships List Page] Contact Relationships Page Requested',
  ContactRelationshipsPageLoaded = '[Contact Relationships API] Contact Relationships Page Loaded',
  ContactRelationshipsPageCancelled = '[Contact Relationships API] Contact Relationships Page Cancelled',
  ContactRelationshipsPageToggleLoading = '[Contact Relationships] Contact Relationships Page Toggle Loading',
  ContactRelationshipActionToggleLoading = '[Contact Relationships] Contact Relationships Action Toggle Loading',
  ThrowContactRelationshipError = '[Contact Relationships] Throw Contact Relationship Error',
  ClearContactRelationshipErrors = '[Contact Relationships] Clear Contact Relationship Errors',
  ClearContactRelationshipState = '[Contact Relationships] Clear Contact Relationship State',
}

export class ContactRelationshipOnServerCreated implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipOnServerCreated;

  constructor(
    public payload: {
      contactRelationship: ContactRelationshipModel;
      contact?: ContactModel;
      doctor?: Doctor;
      contact_id?: number;
      type?: string;
      agreement?: any;
    },
  ) {}
}

export class ContactRelationshipCreated implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipCreated;

  constructor(public payload: { contactRelationship: ContactRelationshipModel; type?: string }) {}
}

export class ContactRelationshipOnServerUpdated implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipOnServerUpdated;

  constructor(
    public payload: {
      partialContactRelationship: Update<ContactRelationshipModel>; // For State update
      contactRelationship: ContactRelationshipModel;
      agreement?: any;
    },
  ) {}
}

export class ContactRelationshipUpdated implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipUpdated;

  constructor(
    public payload: {
      partialContactRelationship: Update<ContactRelationshipModel>; // For State update
      contactRelationship: ContactRelationshipModel;
      contact?: ContactModel;
      fromWhere?: string;
      agreement?: any;
    },
  ) {}
}

export class ContactRelationshipStoreUpdated implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipStoreUpdated;

  constructor(
    public payload: {
      contactRelationship: Update<ContactRelationshipModel>;
      contact?: ContactModel;
      doctor?: Doctor;
      patient?: PatientModel;
      facility?: FacilityModel;
    },
  ) {}
}

export class OneContactRelationshipOnServerDeleted implements Action {
  readonly type = ContactRelationshipActionTypes.OneContactRelationshipOnServerDeleted;
  constructor(
    public payload: {
      contactRelationship: ContactRelationshipModel;
      contact?: ContactModel;
      doctor?: Doctor;
      patient?: PatientModel;
      facility?: FacilityModel;
    },
  ) {}
}

export class OneContactRelationshipDeleted implements Action {
  readonly type = ContactRelationshipActionTypes.OneContactRelationshipDeleted;

  constructor(public payload: { contactRelationship: ContactRelationshipModel }) {}
}

export class ContactRelationshipsPageRequested implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipsPageRequested;

  constructor(
    public payload: {
      page: QueryParamsModel;
      contactId: number;
      type?: string;
      fromwhere?: string;
    },
  ) {}
}

export class ContactRelationshipsPageLoaded implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipsPageLoaded;

  constructor(
    public payload: { contactRelationships: ContactRelationshipModel[]; totalCount: number },
  ) {}
}

export class ContactRelationshipsPageCancelled implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipsPageCancelled;
}

export class ContactRelationshipsPageToggleLoading implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ContactRelationshipActionToggleLoading implements Action {
  readonly type = ContactRelationshipActionTypes.ContactRelationshipActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowContactRelationshipError implements Action {
  readonly type = ContactRelationshipActionTypes.ThrowContactRelationshipError;

  constructor(public payload: { error: any }) {}
}

export class ClearContactRelationshipErrors implements Action {
  readonly type = ContactRelationshipActionTypes.ClearContactRelationshipErrors;
}

export class ClearContactRelationshipState implements Action {
  readonly type = ContactRelationshipActionTypes.ClearContactRelationshipState;
}

export type ContactRelationshipActions =
  | ContactRelationshipOnServerCreated
  | ContactRelationshipStoreUpdated
  | ContactRelationshipCreated
  | ContactRelationshipOnServerUpdated
  | ContactRelationshipUpdated
  | OneContactRelationshipOnServerDeleted
  | OneContactRelationshipDeleted
  | ContactRelationshipsPageRequested
  | ContactRelationshipsPageLoaded
  | ContactRelationshipsPageCancelled
  | ContactRelationshipsPageToggleLoading
  | ContactRelationshipActionToggleLoading
  | ThrowContactRelationshipError
  | ClearContactRelationshipErrors
  | ClearContactRelationshipState;
